export class User {
  constructor(
     public _id?:string,
     public user_name?:string,
     public first_name?:string,
     public last_name?:string,
     public mail_id?:string,
     public phone?:string,
     public password?:string,
     public re_password?:string,
     public role?:string,
     public question?:string,
     public answer ?:string,
     public defaultLang ?: string,
     public organization ?: string,
     public designation ?: string,
     public sub_status ?: string,
     public status ?: string,
     public country ?: string,
     public user_id ?: string,
     public community_id ?: string,
     public profile_pic ?: string,
     public created_by ?: string,
     public updated_by ?: string,
     public comm_role ?: string,
     public business_unit ?: string,
     public is_deleted ?: boolean,
     public community_user ?: boolean,
     public created_date ?: number,
     public updated_date ?: number,
     public last_login ?: number,
     public language_arr ?: Array<any>
  ){}

}



// WEBPACK FOOTER //
// ./src/app/models/Users.ts